import { TextPassage } from '@petsmart-ui/sparky';

import { ResponsivePicture } from '@libs/shared-ui';

import { ImageType, useProduct } from '@/entities/product';

export const ProductInfo = () => {
    const { product } = useProduct();

    if (!product || !product.media.length) return null;

    // TODO: Need to add fallback src image
    const firstImage = product.media.find(item => item.type === 'image') as ImageType | undefined;

    return (
        <div className="fulfilment-selection-drawer__product">
            <div className="fulfilment-selection-drawer__product-image">
                <ResponsivePicture src={firstImage?.url || ''} alt={product.name} size={{ width: 80, height: 80 }} />
            </div>
            <div className="fulfilment-selection-drawer__product-name">
                <TextPassage>{product.name}</TextPassage>
            </div>
        </div>
    );
};
